
import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchRecentActivityDone = (_, { payload }) => {
  
  return [
    ...payload,
  ];
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_RECENT_ACTIVITY_DONE]: fetchRecentActivityDone
});
